import { SearchInput } from 'common/components/cookbook/Search/SearchInput';
import { useFormatMessage } from 'common/hooks/useFormatMessage';

export function FundingsSearchInput() {
  const formatMessage = useFormatMessage();

  return <SearchInput disabled placeholder={formatMessage('vendors.search_fundings')} />;
}
